import { withTranslation } from 'react-i18next';
import YearPicker from './YearPicker.component';
import I18N_DOMAIN_COMPONENTS from '../../../constants';

export default withTranslation(I18N_DOMAIN_COMPONENTS)(YearPicker);
